var map = {
	"./calendar.webp": 1525,
	"./cash.webp": 1526,
	"./check-in-title-bg.webp": 1527,
	"./coin.webp": 1528,
	"./current-check-in-container.webp": 1529,
	"./current-last-day-check-in-container.webp": 1530,
	"./daily-check-in-bg.webp": 1531,
	"./default-check-in-container.webp": 1532,
	"./giftbox.webp": 1533,
	"./golden-coin.webp": 1534,
	"./halfweek-check-in-container.webp": 1535,
	"./last-day-check-in-container.webp": 1536,
	"./missed-checkIn.webp": 1537,
	"./more-cash.webp": 1538,
	"./more-coin.webp": 1539,
	"./more-spin.webp": 1540,
	"./need-deposit.webp": 1541,
	"./present.webp": 1542,
	"./reward-coin.webp": 1543,
	"./shine.webp": 1544,
	"./silver-coin.webp": 1545,
	"./spin.webp": 1546
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 151;